import { t } from 'i18next';
import { Box, Typography, Link } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useBuilding } from './hooks';
import { BuildingTable } from './BuildingTable';
import { CreateBuildingModal } from './CreateBuildingModal.tsx';
import { BuildingItem } from './components';
import { Dropdown, DropdownMenuItem } from '@components';
import { ImportBuildingModal } from '@views/pages/Admin/Buildings/ImportBuildingModal.tsx';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import { theme } from '@store';

export const Building = () => {
  const {
    totalCount,
    entries = [],
    isLoading,
    handleCloseDrawer,
    handleOpenBuildingDetails,
    isDrawerOpen,
    selectedBuildingId,
    isCreateBuildingModalOpen,
    handleOpenCreateBuildingModal,
    handleCloseCreateBuildingModal,
    isImportBuildingModalOpen,
    handleOpenImportBuildingModal,
    handleCloseImportBuildingModal,
    isInitialFilters,
  } = useBuilding();

  const dropdownMenu: DropdownMenuItem[] = [
    {
      iconName: 'homeWork',
      label: t('adminPanel.buildings.dropdown.addBuilding'),
      onClick: handleOpenCreateBuildingModal,
    },
    {
      iconName: 'backup',
      label: t('adminPanel.buildings.dropdown.importBuildings'),
      onClick: handleOpenImportBuildingModal,
    },
  ];

  return (
    <>
      <Box
        sx={{
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          cursor: 'pointer',
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            gap: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <ArrowBack sx={{ fontSize: '1.5rem' }} />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                cursor: 'pointer',
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                />
              </Link>
            </Box>
            <Typography variant='h4'>
              {t('adminPanel.buildings.title')}
            </Typography>
          </Box>
          <Dropdown menuList={dropdownMenu} />
        </Box>
      </Box>
      {entries.length === 0 && isInitialFilters && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <MapsHomeWorkIcon
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('adminPanel.buildings.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.buildings.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <BuildingTable
          rows={entries}
          totalCount={totalCount}
          onSelectBuilding={handleOpenBuildingDetails}
          loading={isLoading}
          selectedRowId={selectedBuildingId}
        />
      )}
      {selectedBuildingId && (
        <BuildingItem
          open={isDrawerOpen}
          itemId={selectedBuildingId}
          handleClose={handleCloseDrawer}
        />
      )}
      <CreateBuildingModal
        isOpen={isCreateBuildingModalOpen}
        handleClose={handleCloseCreateBuildingModal}
        handleOpenBuildingDetails={handleOpenBuildingDetails}
      />
      <ImportBuildingModal
        isOpen={isImportBuildingModalOpen}
        handleClose={handleCloseImportBuildingModal}
      />
    </>
  );
};
